/**
 * Слайдер главной — разметка 1:1 с legacy htdocs/core/templates/admin_slider.tpl:
 * .infobox с кнопкой «Добавить изображение» (.showForm.bt.green), плитка #admSlider
 * (ul/li с фоновым изображением и кнопкой «Удалить изображение»), подложка .fBG
 * и форма загрузки .daddform.
 *
 * Поведение legacy-скрипта сохранено: .showForm показывает форму и подложку,
 * клик по .fBG прячет их.
 *
 * API: GET /api/admin/content/slides, POST /api/admin/content/slides (multipart, поле file),
 * DELETE /api/admin/content/slides/{id} (Handlers\Admin\Content).
 * Картинки отдаются по legacy-URL /slides/{name}.
 */

import { useRef, useState } from 'react'

import { api, ApiError } from '@/api/client'
import { useLegacyCss } from '@/lib/legacyAssets'
import { useApi } from '@/lib/useApi'

/** Слайд (таблица index_slides). */
interface Slide {
  id: number
  name: string
}

export function AdminSliderPage() {
  useLegacyCss('admin', 'newapproach', 'jExplorer') // .fBG/.daddform приходят из jExplorer.css

  const { data, reload } = useApi<Slide[]>('/api/admin/content/slides')
  const fileInput = useRef<HTMLInputElement>(null)

  const [formOpen, setFormOpen] = useState(false)
  const [ok, setOk] = useState<string[]>([])
  const [error, setError] = useState<string[]>([])

  const slides = data ?? []

  /** legacy file-submit. */
  const upload = async (): Promise<void> => {
    const file = fileInput.current?.files?.[0]
    if (file === undefined) {
      setError(['Не выбран файл для загрузки.'])
      return
    }
    const form = new FormData()
    form.append('file', file)
    try {
      const result = await api.upload<{ message: string }>('/api/admin/content/slides', form)
      setOk([result.message])
      setError([])
      setFormOpen(false)
      reload()
    } catch (e: unknown) {
      setError([e instanceof ApiError ? e.message : 'Ошибка при загрузке файла.'])
      setOk([])
    }
  }

  /** legacy file-delete[id]. */
  const remove = async (id: number): Promise<void> => {
    try {
      const result = await api.delete<{ message: string }>(`/api/admin/content/slides/${id}`)
      setOk([result.message])
      setError([])
      reload()
    } catch (e: unknown) {
      setError([e instanceof ApiError ? e.message : 'Ошибка при удалении файла.'])
      setOk([])
    }
  }

  return (
    <>
      <div className="infobox clearfix">
        {error.map((message, index) => (
          <p key={index} className="okke" style={{ color: '#ce4844', float: 'left' }}>
            {message}
          </p>
        ))}
        {ok.map((message, index) => (
          <p key={index} className="okke" style={{ float: 'left' }}>
            {message}
          </p>
        ))}
        <div style={{ float: 'right' }}>
          <a
            className="showForm bt green"
            href="#"
            onClick={(e) => {
              e.preventDefault()
              setFormOpen(true)
            }}
          >
            Добавить изображение
          </a>
        </div>
      </div>

      <br />

      <div id="admSlider">
        <ul style={{ paddingLeft: 0, fontSize: 0 }}>
          {slides.map((slide) => (
            <li key={slide.id} style={{ width: '23%', margin: '1%', minWidth: '200px' }}>
              <div
                style={{
                  position: 'relative',
                  overflow: 'hidden',
                  background: `url('/slides/${slide.name}') center`,
                  backgroundSize: 'cover',
                  height: '200px',
                  borderRadius: '3px',
                  boxShadow: '0px 0px 3px 0px rgba(0,0,0,0.75)',
                }}
              >
                <form
                  method="POST"
                  style={{ position: 'absolute', bottom: 0, display: 'block', width: '100%' }}
                  onSubmit={(e) => {
                    e.preventDefault()
                    void remove(slide.id)
                  }}
                >
                  <input
                    className="bt red"
                    style={{ width: '100%', margin: 0, padding: '5px', borderRadius: 0 }}
                    type="submit"
                    name={`file-delete[${slide.id}]`}
                    value="Удалить изображение"
                  />
                </form>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div
        className="fBG"
        style={{ display: formOpen ? 'block' : 'none' }}
        onClick={() => setFormOpen(false)}
      />

      <form
        method="POST"
        className="daddform"
        encType="multipart/form-data"
        style={{ display: formOpen ? 'block' : 'none' }}
        onSubmit={(e) => {
          e.preventDefault()
          void upload()
        }}
      >
        <span>Добавление слайда</span>
        <input className="" type="file" name="file" accept="image/*" ref={fileInput} />
        <input className="btn btn-xs btn-success" type="submit" name="file-submit" value="Загрузить" />
      </form>
    </>
  )
}
